import type { MediaPlan } from '@mint-sdk/api-media-plan';
import { getRouteApi } from '@mint/routing';

import { useSidebarTreeApi } from '../api/queries/useSidebarTreeApi.js';
import { MP_LEVELS } from '../consts/index.js';
import { getActivityIdForLevel } from '../utils/activityColumns.js';
import { useChosenLevel } from './useChosenLevel.js';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const useColumnsView = (): {
  viewType: MediaPlan.ColumnsViewType;
  relatedEntityId: string;
} => {
  const { campaignId: planId } = routerApi.useParams();
  const { id, level } = useChosenLevel();
  const { data: sidebarTree } = useSidebarTreeApi();

  if (level === MP_LEVELS.MEDIA_PLAN) {
    return { viewType: 'media_plan', relatedEntityId: planId };
  }

  return {
    viewType: 'flight',
    relatedEntityId: getActivityIdForLevel(level, id, sidebarTree),
  };
};
